<template>
  <div>
    <h1 class="text-xl">文件闪传</h1>
    <hr class="my-4">
    <SpaceOpener>
      <Ingress />
    </SpaceOpener>
  </div>
</template>

<script>
import SpaceOpener from '../components/space-opener'
import Ingress from '../components/ingress'

export default {
  name: 'IngressPage',
  props: [],
  components: {
    SpaceOpener,
    Ingress,
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>

